import commonAxois from '@/services/axios/common.axios';
import urlsConf from "../../../config/urls.conf";

const commonService = {

  /**
   * Environment 에 따른 url정보 가지고 오기
   * @returns {env : 'DEV', ssoUrl : '', portalUrl : ''}
   */
  getFrontProfile() {
    return commonAxois.get(`/api/general/frontProfile`, {
      excludeToken: true
    });
  },

  /**
   * 홈페이지 정보 불러오
   * @returns {*}
   */
  getHomepageInfo(host, lang) {
    return commonAxois.get(`${urlsConf.apiGwUrl}/platform/v1/plat/sites/info?host=${host}&langcd=${lang}`, {
      excludeToken: true
    });
  },

  /**
   * 현재 로그인한 사용자 정보 조회
   */
  getCurrentLoginUserInfo() {
    return commonAxois.get(`${urlsConf.apiGwUrl}/platform/v1/plat/users/current-logged-in`);
  },
}

export default commonService;



// WEBPACK FOOTER //
// ./src/services/common/common.service.js